class Research {
  constructor (el) {
    this.el = el
    this.initDefaults()
  }

  initDefaults () {
    this.initEvents()
    this.setWidth()
  }

  initEvents () {
    window.addEventListener('resize', e => this.onResize())
  }

  onResize () {
    if (window.innerWidth < 1280) return;
    this.setWidth()
  }

  setWidth () {
    const elWidth = this.el.offsetWidth
    const offsetX = this.el.getBoundingClientRect().left
    const wWidth = window.innerWidth
    const diff = wWidth - (elWidth + offsetX)
    
    this.el.style.width = elWidth + diff + 'px'
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const el = document.querySelectorAll('.js-research')

  if (el.length) {
    el.forEach(el => {
      new Research(el)
    })
  }
})